<template>
  <div>
    <OrisSwiper
      :centered-slides="false"
      :modules="[Scrollbar, FreeMode]"
      free-mode
      :scrollbar="{ hide: false }"
      slides-per-view="auto"
      :space-between="swiperSpaceBetween"
    >
      <SwiperSlide
        v-for="(image, index) in images"
        :key="`${images}_${index}`"
        @click="() => $emit('setActive', index)"
      >
        <div
          class="h-full w-full bg-grey-light-02 hover:opacity-100"
          :class="{
            'opacity-100': active === index,
            'opacity-50': active !== index,
          }"
        >
          <slot name="image" v-bind="image" :index="index" />
        </div>
      </SwiperSlide>
    </OrisSwiper>
  </div>
</template>

<script setup lang="ts" generic="T extends MediaImageProps">
import { SwiperSlide } from 'swiper/vue'
import { Scrollbar, FreeMode } from 'swiper/modules'
import type { MediaImageProps } from '../Media/Image/index.vue'

const swiperSpaceBetween = 16
const swiperSpaceBetweenPx = `${swiperSpaceBetween}px`

withDefaults(
  defineProps<{
    active: number
    images: T[]
  }>(),
  {
    active: 0,
    images: () => [],
  },
)

defineEmits<{
  setActive: [idx: number]
}>()

defineSlots<{
  image(props: { index: number } & T): void
}>()
</script>

<style lang="scss" scoped>
/* stylelint-disable no-invalid-position-at-import-rule */

:deep() {
  @import 'swiper/scss';
  @import 'swiper/scss/scrollbar';
}

:deep(.swiper) {
  display: flex;
  flex: 1;
  left: 0;
  right: 0;

  .swiper-wrapper {
    pointer-events: none;
    padding-bottom: 17px;
  }

  .swiper-slide {
    pointer-events: auto;
    width: 180px;
    height: 180px;

    &:last-child {
      padding-right: v-bind(swiperSpaceBetweenPx);
    }
  }

  .swiper-scrollbar {
    cursor: pointer;
    border-radius: 0;
    height: 1px;
    bottom: 0;

    &-horizontal {
      @apply bg-grey-light-01;

      opacity: 1;
      flex: 1;
      width: 100%;
      left: 0;
    }

    &-drag {
      border-radius: 0;
      background-color: #000;
      opacity: 1;
    }
  }
}
</style>
